import React, { Fragment } from 'react';
import { Transition } from '@headlessui/react';
import { FaChevronUp } from 'react-icons/fa';
import { MdOutlineCheck } from 'react-icons/md';
import { Combobox } from '@headlessui/react';
import { InputLabelContainer } from '../../label/containers/input-label.container';

export function MultiSelectTextComponent({
  label,
  filtered,
  handleOptionClick,
  onValueChange,
  isDisabled,
  handleInputChange,
  selected,
  handleButtonClick,
  isRequired,
  multiple,
  open,
  displaySelected,
  handleInputKeyDown
}: any) {

  return (
    <div>
      <InputLabelContainer isRequired={isRequired} label={label} />
      <Combobox value={selected} onChange={onValueChange} multiple={multiple}>
        <div className="relative mt-1">
          <div>
            <Combobox.Input
              className={`w-full pl-4 pr-7 py-2 border rounded-md ${
                isDisabled
                  ? 'bg-gray-200 cursor-not-allowed'
                  : 'bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500'
              }`}
              placeholder="Type something and press enter..." 
              onKeyDown={handleInputKeyDown}
              onChange={handleInputChange}
              displayValue={displaySelected}
            />
            <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2" onClick={handleButtonClick}>
              <FaChevronUp className={`h-4 w-4 text-gray-400 text-center transform ${open ? 'rotate-180' : ''}`} />
            </Combobox.Button>
          </div>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => ('')}
          >
             <Combobox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm z-10">
              {filtered.map((data: any) => (
                <Combobox.Option 
                className={({ active }) =>
                `relative cursor-default select-none py-2 pl-10 pr-4 ${
                  active ? 'bg-skin-ouprimary' : 'text-skin-ouprimary'
                }`
              }
                key={data.id} 
                value={data}>
                  <div onClick={() => handleOptionClick(data)} className={data.isNew ? 'text-skin-ouprimary cursor-pointer' : 'cursor-pointer'}>
                    {data.label}
                    {selected.some((value: any) => value.id === data.id) && (
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-skin-ouprimary">
                         <MdOutlineCheck className="h-5 w-5" aria-hidden="true" />
                      </span>
                    )}
                  </div>
                </Combobox.Option>
              ))}
             
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </div>
  );
}